import { Link, useLocation, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import Seo from "@/components/Seo";
import { money } from "@/lib/api";

export default function Confirmation() {
    const { orderId } = useParams();
    const { state } = useLocation() || {};
    const order = state || {};

    return (
        <div className="pt-32 md:pt-40 pb-24" data-testid="confirmation-page">
            <Seo
                title="Order Confirmed — District Greenz DMV"
                description="Your District Greenz DMV order has been received."
                path="/order"
            />
            <div className="container-x max-w-2xl text-center">
                <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-leaf/40 bg-leaf/10" data-testid="confirmation-icon">
                    <CheckCircle2 size={36} className="text-leaf-bright" />
                </div>
                <p className="eyebrow mt-8 text-gold">Order received</p>
                <h1 className="mt-4 font-display text-4xl md:text-5xl font-extrabold text-bone">
                    You're all set.
                </h1>
                <p className="mt-5 text-bone/70 leading-relaxed" data-testid="confirmation-message">
                    {order.fulfillment === "pickup"
                        ? "We'll have your order ready at the shop — 10 Florida Ave NW, open 24 hours, Monday–Sunday. Pay when you pick up, and bring a valid 21+ ID."
                        : "Your order is on its way. Have cash ready and answer the door with a valid 21+ government-issued ID."}
                </p>

                <div className="mt-10 grid gap-3 rounded-3xl border border-leaf/15 bg-moss/40 p-6 text-left sm:grid-cols-3" data-testid="confirmation-details">
                    <div>
                        <p className="eyebrow text-sage">Order</p>
                        <p className="mt-1.5 font-display font-bold text-bone" data-testid="confirmation-order-id">#{orderId}</p>
                    </div>
                    <div>
                        <p className="eyebrow text-sage">Status</p>
                        <p className="mt-1.5 font-display font-bold capitalize text-leaf-bright" data-testid="confirmation-status">{order.status || "pending"}</p>
                    </div>
                    <div>
                        <p className="eyebrow text-sage">Total (cash)</p>
                        <p className="mt-1.5 font-display font-bold text-bone" data-testid="confirmation-total">
                            {order.total != null ? money(order.total) : "—"}
                        </p>
                    </div>
                </div>

                <div className="mt-10 flex flex-wrap justify-center gap-4">
                    <Link to="/shop" data-testid="confirmation-shop-cta" className="rounded-full bg-leaf px-8 py-4 font-bold text-ink hover:bg-leaf-bright transition-colors">
                        Keep Shopping
                    </Link>
                    <a href="tel:+12027134325" data-testid="confirmation-call-cta" className="rounded-full border border-bone/25 px-8 py-4 font-semibold text-bone hover:border-leaf/50 transition-colors">
                        Questions? (202) 713-4325
                    </a>
                </div>
            </div>
        </div>
    );
}
